import { Anchor } from 'antd';
import React from 'react';

const AnchorContainer: React.FC<any> = (props) => {
  const { anchorItems, container } = props;

  const handleClick = (
    e: React.MouseEvent<HTMLElement>,
    link: {
      title: React.ReactNode;
      href: string;
    }
  ) => {
    e.preventDefault();
    console.log(link);
    const element = document.getElementById(link.href.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      {anchorItems ? (
        <div className="anchor-menu custom-scrollbar">
          <div style={{ padding: '12px 0' }}>目次</div>
          <Anchor
            onClick={handleClick}
            getContainer={() => {
              return container || window;
            }}
            items={anchorItems}
          />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default AnchorContainer;
